import React from 'react';
import { AirplaneTilt } from '@phosphor-icons/react';
import ComingSoonPage from './ComingSoonPage';

const LogisticsFlightsPage = () => (
  <ComingSoonPage
    Icon={AirplaneTilt}
    tag="CHARTER · SEAT · WEATHER"
    title="Flight booking is coming in Phase 2."
    phase="Phase 2 · Food + Transport + Flights"
    testid="ls-flights"
    bullets={[
      'Charter, commercial, and helicopter options with weight/baggage limits',
      'Seat allocation with team affinity — force real prioritisation',
      'Weather-dependent availability injected by SimCell',
      'Rush surcharges for last-minute bookings',
      'Full booking → hold → capture flow shared with accommodation',
    ]}
  />
);
export default LogisticsFlightsPage;
